module.exports = __webpack_public_path__ + "img/login-one.63e57de3.png";